import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { APIService } from 'src/app/services/api';
import { FavoritedComponent } from '../icons/favorited';
import { FavoriteComponent } from '../icons/favorite';
import { PencilComponent } from '../icons/pencil';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company',
  imports: [
    CommonModule,
    FavoritedComponent,
    FavoriteComponent,
    PencilComponent
  ],
  template: `
    <div
      (click)="selectCompany(company)"
      class="p-[12px] flex justify-between align-middle items-center cursor-pointer rounded-lg"
      [ngClass]="{
        'bg-[#043B22]/5 border-[2px] border-[#043B22] !p-[10px]':
          company.id === currentCompany?.id && (router.url.includes('/dashboard/calculations') || router.url.includes('/dashboard/emission'))
      }"
    >
      <div
        class="flex gap-4 align-middle items-center max-w-64 text-ellipsis overflow-hidden whitespace-nowrap text-[14px]"
      >
        <div
          class="size-6 rounded-full bg-cover bg-center"
          [ngStyle]="{
            backgroundImage:
              company?.companyLogo?.length > 0
                ? 'url(' + company.companyLogo + ')'
                : 'url(/images/welcome.png)'
          }"
        ></div>
        {{ company.companyName }}
      </div>
      <div class="flex gap-2 align-middle items-center">
        <div
          *ngIf="company.id === currentCompany?.id"
          class=""
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            editCompany()
          "
        >
          <app-pencil></app-pencil>
        </div>
        <div
          *ngIf="!company.isFavorite"
          class=""
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            favoriteCompany(company.id)
          "
        >
          <app-favorite></app-favorite>
        </div>
        <div
          *ngIf="company.isFavorite"
          class=""
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            unfavoriteCompany(company.id)
          "
        >
          <app-favorited></app-favorited>
        </div>
      </div>
    </div>
  `
})
export class CompanyComponent {
  @Input() company: any;
  @Input() refresh: any;
  @Input() selectCompany: any;
  @Input() currentCompany: any;

  public router = inject(Router);
  private api = inject(APIService);
  private spinner = inject(NgxSpinnerService);

  editCompany = async () => {
    this.router.navigateByUrl('/dashboard/company');
  };

  favoriteCompany = async (id: string) => {
    this.spinner.show();
    await this.api.UpdateCompany({ id, isFavorite: true });
    this.refresh();
  };

  unfavoriteCompany = async (id: string) => {
    this.spinner.show();
    await this.api.UpdateCompany({ id, isFavorite: false });
    this.refresh();
  };
}
